(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alamira-pdp-main"]) return;
  try {
    
  (() => {
    const groupServiceAccordions = (root) => {
      root.querySelectorAll('.aa-pdp__buy .accordion').forEach((accordion, index) => {
        const sectionId = accordion.closest('.shopify-section')?.id;
        if (!sectionId) return;

        const groupName = `aa-pdp-services-${sectionId}-${index}`;

        accordion.querySelectorAll(':scope > accordion-custom > details').forEach((details) => {
          details.setAttribute('name', groupName);
        });
      });
    };

    groupServiceAccordions(document);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) {
        groupServiceAccordions(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
